import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSettingsDocumentsCategoryDialogStore } from './service-settings-documents-category-dialog.store';
import { TextInputComponent } from 'packages/client/src/app/components/kit/input/text-input/text-input.component';
import { BaseDialogComponent } from 'packages/client/src/app/components/kit/base-dialog/base-dialog.component';
import { CategoryGridItemObject, FileCategoryCreateInput, FileCategoryUpdateInput } from '@it2go/types';
import { AppFormGroup } from 'packages/client/src/app/utils/form.utils';
import { fb } from 'packages/client/src/app/modules/shared/shared.global-service';
import { Validators } from '@angular/forms';
import { isInvalid } from 'packages/client/src/app/modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../content.error';
import { ExternalType } from '@libs/types/src/file-manager/enum/external-type.enum';
import { CheckInputComponent } from '../../../../../../../components/kit/input/check-input/check-input.component';


@Component({
    selector: 'app-service-settings-documents-category-dialog',
    templateUrl: 'service-settings-documents-category-dialog.component.html',
    styleUrl: 'service-settings-documents-category-dialog.component.scss',
    providers: [ServiceSettingsDocumentsCategoryDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextInputComponent,
        CheckInputComponent,
    ],
})
export class ServiceSettingsDocumentsCategoryDialogComponent extends BaseDialogComponent {
    public readonly store = inject(ServiceSettingsDocumentsCategoryDialogStore);

    protected category: CategoryGridItemObject | null = null;
    protected serviceId!: number;

    protected form = new AppFormGroup({
        name: fb.control<string>('', Validators.required),
        active: fb.control<boolean>(true),
    });

    protected prefix = 'service.settings.documents.category.';

    constructor() {
        super();

        this.category = this.dialogConfig.data.category;
        this.serviceId = this.dialogConfig.data.serviceId;

        if (this.category) {
            this.form.patchValue({
                ...this.category,
            });
        }
    }

    override save(_event: Event): void | Promise<void> {
        if (isInvalid(this.form)) return;

        const _baseData = {
            name: this.form.value.name,
            active: this.form.value.active,
        };

        if (!this.category) {
            const data = _baseData as FileCategoryCreateInput;
            data.accessess = [
                { externalId: this.serviceId.toString(), externalType: ExternalType.service },
            ];

            this.store.api.createFileCategory(data).then(() => {
                contentGlobalSuccess.next('common.created');
                this.dialogRef.close({ refresh: true });
            });
        } else {
            const data = _baseData as FileCategoryUpdateInput;
            data.id = this.category.id;

            this.store.api.updateFileCategory(data, 'id').then(() => {
                contentGlobalSuccess.next('common.updated');
                this.dialogRef.close({ refresh: true });
            });
        }
    }
}
